<template>
  <section class=" card">

    <header class="card-header">
      <p class="card-header-title">Name Label</p>
      <button class="card-header-icon">
      <span >
        <b-tag type="is-grey-light">Silver 70x32</b-tag>
      </span>
      </button>

    </header>
    <div class="card-content">
      <b-field label="Your Name">
        <b-input v-model="line1" value="E.g. Test ">
        </b-input>
      </b-field>

      <b-field grouped>
        <b-field label="Show Preview">
          <p class="control">
            <b-button class="button is-primary" @click="previewZPL">Preview</b-button>
          </p>
        </b-field>

        <b-field
            label="Amount"
            type="is-primary">
          <b-select v-model="amountOfLabels">
            <option :value="1">1</option>
            <option :value="2">2</option>
            <option :value="3">3</option>
            <option :value="4">4</option>
            <option :value="5">5</option>
            <option :value="6">6</option>
          </b-select>
        </b-field>
        <b-field label="Print">
          <b-button @click="printZPL">
            Print Tags
          </b-button>
        </b-field>
      </b-field>


    </div>

  </section>
</template>

<script>

import moment from "moment/moment";

export default {
  data() {
    return {
      amountOfLabels: 1,
      line1: '',
    };
  },
  methods: {

    previewZPL() {
      this.$emit("previewZPL", this.generateLabelZPL())
    },

    printZPL() {

      let res = []
      for (let i = 0; i < this.amountOfLabels; i++) {
        res.push(this.generateLabelZPL())
      }

      this.$emit("printZPL", res)
    },

    generateLabelZPL() {
      return `^XA
 ^FX Side Logo
^FO476,20^GFA,2400,2400,10,,:::::::U0F,T07FC,S03IF,U03F,V078,V03C,W0C,W04,Q02K02,Q04,Q08,P018,P03,P07,:P0F,::::P07,:P03,P038,P018,Q0C,Q02K02,W04,W0C,V01C,V078,U01F8,S03IF,T0FFE,T01F8,,:::::::::::S0FE,R03FF8,R07C7C,R0F01E,Q01C007,Q018003,Q0380038,:Q03I018,:::Q0380038,:Q01C007,:R08002,,::::::::Q03IF8,Q03IFC,Q03JF,,:::::::U018,:::::U038,Q03JF8,:U038,U018,:::::,::::V08,U038,U078,T01F,T03C,T0F8,S03E,S078,Q03FF,:S078,S01E,T0F8,T03C,U0F,U078,U018,,:::::::Q03JF8,::T01F,T07C,T0F,S03C,S0F8,S06,,:R018,R01E,S0F8,S03C,T0F,T07C,T01E,Q03JF8,::,::::::::::Q03JF8,:Q0383838,Q0301818,::::::::Q03I018,Q01,,:::::::Q01C07C,Q0180FE,Q0380FF,Q0381C38,Q0301838,Q0301818,Q0303818,:Q0303018,Q0307018,Q0387038,Q01FE03,:R078,,::::::::Q03JF8,::S038,S018,::::::::S038,Q03JF8,::,:::::::^FS
 ^FX Main Label Text
 ^CF0,75
 ^FO0,90^FB500,3,5,C,0^FD${this.line1}\\&^FS
 ^FX Bottom section
 ^LRN
 ^FO0,210^GB500,55,55^FS
 ^LRY
 ^CF0,25
 ^FO0,223^FB500,3,5,C,0^FDevents@citymesh.com | +32 14 40 45 95\\&^FS
 ^XZ`
    },

  },
};
</script>
